import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { Bunting } from "@/components/art/Poster";
import { InviteCard } from "@/components/invite/InviteCard";
import { http } from "@/lib/api";
import { moodById } from "@/lib/event";

export default function CardPage() {
  const { cardId } = useParams();
  const [ev, setEv] = useState(null);
  const [card, setCard] = useState(null);
  const [missing, setMissing] = useState(false);
  useEffect(() => {
    http.get("/event").then((r) => setEv(r.data)).catch(() => setMissing(true));
    http.get(`/card/${cardId}`).then((r) => setCard(r.data)).catch(() => setMissing(true));
  }, [cardId]);
  return (
    <main className="paper min-h-screen pb-16">
      <Bunting className="h-[48px] w-full md:h-[64px]" width={1440} flags={26} />
      <div className="mx-auto max-w-md px-5 pt-6 text-center">
        {missing && <p className="font-poster py-20 text-4xl text-[var(--navy)]" data-testid="card-not-found">This pass couldn’t be found. But the party is still on.</p>}
        {ev && card && (
          <>
            <p className="eyebrow mb-5">A personal invitation</p>
            <InviteCard ev={ev} name={card.name} mood={moodById(card.mood)} accepted={!!card.rules_accepted} />
          </>
        )}
        <Link to="/" className="btn-primary mt-8" data-testid="open-full-invitation">Open the full invitation</Link>
      </div>
    </main>
  );
}
